import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import {
  concatMap,
  delay,
  distinctUntilChanged,
  map,
  retryWhen,
  shareReplay,
  switchMap,
  take
} from "rxjs/operators";

import { SYSTEM_ADMIN } from 'app/types/authority';
import { AccountService } from '../auth/account.service';



@Injectable({
  providedIn: 'root'
})
export class AuthorityService {
  private resourceUrl = 'api/authorities';

  authorities$: Observable<App.Authority[]>

  constructor(
    private http: HttpClient,
    private accountService: AccountService,
  ) {
    this.authorities$ = this.accountService.account$.pipe(
      map(account => !!account && account.authorities.includes(SYSTEM_ADMIN)),
      distinctUntilChanged(),
      switchMap(account => {
        if (account) {
          return this.findAll();
        } else {
          return of([]);
        }
      }),
      retryWhen(errors => errors.pipe(
        delay(1000),
        take(10),
        concatMap(() => of([])))
      ),
      shareReplay(1),
    );
  }

  findAll(): Observable<App.Authority[]> {
    return this.http.get<App.Authority[]>(this.resourceUrl);
  }
}
